module.exports = __webpack_public_path__ + "img/logo.d538d855.png";